<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 施設職員情報詳細（追加・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>施設職員情報詳細（追加・編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/facility-user-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          職員のユーザーIDが表示されます。<br>
          追加時に自動設定され、編集はできません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> メールアドレス
        </div>
        <div class="manual-explain">
          メールアドレスを設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 名称
        </div>
        <div class="manual-explain">
          名称を設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 施設リスト
        </div>
        <div class="manual-explain">
          職員の所属する施設を設定します。<br>
          施設リスト追加ボタンから施設を選択します。<br>
          施設リストはドラッグ&ドロップで並び替えが可能です。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 詳細
        </div>
        <div class="manual-explain">
          詳細を設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Facility Staff Information Details (Add/Edit)
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Facility Staff Information Details (Add/Edit)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_facility-user-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          Displays the staff user ID.<br>
          Automatically set when adding and cannot be edited.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Email Address
        </div>
        <div class="manual-explain">
          Set the email address.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Name
        </div>
        <div class="manual-explain">
          Set the name.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Facility List
        </div>
        <div class="manual-explain">
          Set the facilities to which the staff member belongs.<br>
          Select facilities using the Add Facility List button.<br>
          The facility list can be reordered by drag & drop.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Detail
        </div>
        <div class="manual-explain">
          Set the details.<br>
          <span class="manual-explain-notes">*Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to update the edited content.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
